import React from "react";
import { Maybe } from "src/generated/graphqlTypes";

export type HasChildren = { children: React.ReactNode; "data-testid"?: string };

export function isNumber(num: Maybe<number>): num is number {
  return num !== undefined && num !== null;
}

export type HasIdAndName = { id: string; name: string };

export type HasIdAndNameAndTypeName = HasIdAndName & { __typename?: string };

/**
 * Converts all keys of some object to a different type. For example remapping `{ a: string; b: string }`
 * to `{ a: (input: string) => void; b: (input: string) => void }` and keeping them tightly linked.
 */
export type Remap<T, U> = { [K in keyof T]: U };
